import { useEffectOnce } from 'react-use';
import { GTM } from '@app/analytics';
import { getCustomerTraits } from '@app/redux/customer/selectors';
import { useSelector } from 'react-redux';
import identify from '@app/segment/utils/identify';
import { useCustomer, useUserIsLoggedIn } from '@app/user';

/**
 *
 */
const useIdentifyCustomer = () => {
  const customer = useCustomer();
  const isLoggedIn = useUserIsLoggedIn();
  const customerTraits = useSelector(getCustomerTraits);

  useEffectOnce(() => {
    if (!isLoggedIn) {
      return;
    }

    const { email, uuid } = customer ?? {};

    if (uuid && email) {
      identify(uuid, customerTraits);
    }

    GTM.loginSignup('identify', customer);
  });
};

export default useIdentifyCustomer;
